import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import {BdbHeadersModel} from './models/bdb-headers.model';
import {ChannelService} from './channel.service';
import {SandboxRequestService} from './sandbox/sandbox-request.service';
import {ResponseAddSeller} from '../models/response-add-seller.model';

@Injectable()
export class FairService {

    constructor(
        private readonly http: HttpClient,
        private readonly sessionStorageService: BdbSessionStrgService,
        private readonly sandbox: SandboxRequestService,
        private readonly channelService: ChannelService
    ) { }

    public async updateSellerOffice(seller: ResponseAddSeller) {
        const ip = this.sessionStorageService.get(SessionStorageKeysEnum.PUBLIC_IP);
        const office = this.sessionStorageService.get(SessionStorageKeysEnum.OFFICE_CODE);
        const {
            privateIp,
            publicIp,
            adviserUniqueCode,
            identityNumber,
            username,
            identityNumberLdap,
            isFair,
            mediumType,
            alliedCode,
            uuidSellerAuth,
            selfManagement
        } = seller;
        if (ip === null || office === null) {
            console.log('network: ', ip, 'officeCode: ', office);
            throw new Error('IP y OfficeCode deben estar disponibles');
        }
        const body: ResponseAddSeller = {
            privateIp,
            publicIp,
            identityType: 'CC',
            officeNumber: office,
            identityNumber,
            selfManagement,
            username,
            identityNumberLdap,
            isFair,
            mediumType,
            alliedCode,
            uuidSellerAuth,
            adviserUniqueCode
        };
        if (!environment.enableNewAddSeller) {
            return this.http.patch<any>(environment.fairApi + '/sales/add-seller', {
                ip: ip,
                officeNumber: office
            });
        } else {
            return this.addSellerWithSandboxV3(body);
        }
    }

    public async getSeller() {
        const privateIp = this.sessionStorageService.get(SessionStorageKeysEnum.PRIVATE_IP);
        const sellerDocument = this.sessionStorageService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER_LAUNCHER);
        console.log('IP: ', privateIp, 'sellerDocument: ', sellerDocument);
        if (privateIp === null || sellerDocument === null) {
            console.log('network: ', privateIp);
            throw new Error('IP y seller id deben estar disponible');
        }
        if (!environment.enableNewAddSeller) {
            return fetch(`${environment.fairApi}/sales/add-seller?ip=${privateIp}`);
        } else {
            const response = await this.getSellerWithSandboxV3(privateIp, sellerDocument);
            console.log('The response from new add-seller ---->', response)
            return  response;
        }
    }

    getSellerWithSandboxV3(ip: string, sellerDocument: string) {
        const headers: any = this.getHeaders(ip);
        const url = `${ environment.sandboxV3Domain }/adviser/V2/add-seller`;
        const queryParams = {ip: ip, sellerId: sellerDocument};
        console.log('Request', url, headers);
        return this.sandbox.requestGetSandbox(
            url,
            headers,
            queryParams);
    }

    private getHeaders(publicIp: any): BdbHeadersModel {
        const channel = this.channelService.getChannel();
        return {
            'X-Channel': channel,
            'X-IPAddr': publicIp,
        };
    }

    addSellerWithSandboxV3(body: ResponseAddSeller ) {
        const headers: any = this.getHeaders(body.publicIp);
        const url = `${ environment.sandboxV3Domain }/adviser/V2/add-seller`;
        console.log('Request', url, body, headers);
        return this.sandbox.requestPostSandbox(
            url,
            body,
            headers);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/fair.service.ts